export default {
	init() {
		$(function () {
			var $window = $(window),
			$mainMenuBar = $('.headerStick'),
			$menuBarOffset = $mainMenuBar.offset().top + (-1),
			window_top = 0;
			$window.scroll(function() {
				window_top = $window.scrollTop();
				if (window_top >= $menuBarOffset) {
					$mainMenuBar.addClass('stick');
				}
				else {
					$mainMenuBar.removeClass('stick');
				}
			});

			window.onscroll = function() {
				growShrinkLogo()
			};

			var Logo = document.getElementById("Logo");
			var endOfDocumentTop = 20;
			var size = 0;

			$(".showSearch").click(function(){
				$("#searchMobile").show();
			});

			function growShrinkLogo() {
				var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
				if (size == 0 && scroll > endOfDocumentTop) {
					Logo.className = 'smallLogo';
					size = 1;
				} else if(size == 1 && scroll <= endOfDocumentTop){
					Logo.className = 'largeLogo';
					size = 0;
				}
			}

			if ($('#back-to-top').length) {
				var scrollTrigger = 100, // px
					backToTop = function () {
						var scrollTop = $(window).scrollTop();
						if (scrollTop > scrollTrigger) {
							$('#back-to-top').addClass('show');
						} else {
							$('#back-to-top').removeClass('show');
						}
				};

				backToTop();
				$(window).on('scroll', function () {
					backToTop();
				});
				$('#back-to-top').on('click', function (e) {
					e.preventDefault();
					$('html,body').animate({
						scrollTop: 0,
					}, 700);
				});
			}

			if (document.getElementById('schakel-filter')) {
				document.getElementById('schakel-filter').addEventListener('click', e => {
					e.preventDefault();
					document.querySelector('.filter-col').classList.toggle('open');
				});
			}

			if (document.getElementById('schakel-filter2')) {
				document.getElementById('schakel-filter2').addEventListener('click', e => {
					e.preventDefault();
					document.querySelector('.filter-col').classList.toggle('open');
				});
			}

			$('[data-youtube]').click(function () { 
				var id = $(this).attr('data-youtube'); 
				var src = '//www.youtube.com/embed/'+id+'?html5=1&autoplay=1&rel=0';
				var iframe = '<iframe id="youtube" width="100%;" height="258px" class="yt_players" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:258px;width:100%;top:0px;left:0px;right:0px;bottom:0px;z-index:999" src="'+src+'" allowfullscreen></iframe>';
				$(this).find(".video-wrapper").html(iframe);
				return false;
			});

			$('.sliderWoab').slick({
				dots: true,
				arrows: true,
				slidesToShow: 4,
				slidesToScroll: 4,
				speed: 400,
				prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
				nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					},
				}, {
					breakpoint: 580,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: false,
					},
				}],
			});

			$('.sliderBestsellers').slick({
				dots: true,
				arrows: true,
				slidesToShow: 4,
				slidesToScroll: 4,
				speed: 400,
				prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
				nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					},
				}, {
					breakpoint: 580,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: false,
					},
				}],
			});

			$('.sliderMerken').slick({
				dots: false,
				arrows: false,
				slidesToShow: 5,
				slidesToScroll: 4,
				autoplay: true,
				autoplaySpeed: 7000,
				speed: 1500,
				prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
				nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 3,
					},
				}, {
					breakpoint: 580,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: false,
					},
				}],
			});

			$('.couponButton').attr('disabled',true);
			$('#coupon_code').keyup(function(){
				if($(this).val().length !=0) {
					$('.couponButton').attr('disabled', false);
				} else {
					$('.couponButton').attr('disabled', true);        
				}
			});

			if($('body').is('.post-type-archive-product')){
				var s = $(".filterArchive");
				var pos = s.position();
				$(window).scroll(function () {
					var windowpos = $(window).scrollTop();
					if (windowpos >= pos.top) {
						s.addClass("stickFilter");
					} else {
						s.removeClass("stickFilter");
					}
				});
			}

			$('a.readMore').click(function () {
				$(this).siblings('.excerpt').slideToggle(0);
				$(this).siblings('.whole-post').slideToggle(0);
				$(this).hide();
				$("a.readLess").show();
				return false;
			});

			$('a.readLess').click(function () {
				$(this).siblings('.excerpt').slideToggle(0);
				$(this).siblings('.whole-post').slideToggle(0);
				$(this).hide();
				$("a.readMore").show();
				return false;
			});

			$(document).on('click','.js-menu_toggle.closed',function(e){
				e.preventDefault(); $('.list_load, .list_item').stop();
				$(this).removeClass('closed').addClass('opened');
				$('.side_menu').css({ 'left':'0px' });
				var count = $('.list_item').length;
				$('.list_load').slideDown( (count*.6)*100 );
				$('.list_item').each(function(i){
					var thisLI = $(this);
					setTimeout(function(){
						thisLI.css({
							'opacity':'1',
							'margin-left':'0',
						});
					},100*i);
				});
			});

			$(document).on('click','.js-menu_toggle.opened',function(e){
				e.preventDefault(); $('.list_load, .list_item').stop();
				$(this).removeClass('opened').addClass('closed');
				$('.side_menu').css({ 'left':'-250px' });
				$('.list_item').css({
					'opacity':'0',
					'margin-left':'-20px',
				});
				$('.list_load').slideUp(300);
			});

			$(".showText").hover(function(){
				$(this).find(".hide").fadeIn();
			},function(){
                $(this).find(".hide").fadeOut();
            });

			var $container = $('#da-thumbs'),
			$filterLinks = $('#filters a');

			$(window).load(function(){
				if($('body').is('.page-id-364')){
					$("body").removeClass("preload");
					$container.isotope({
						itemSelector: '.box',
						percentPosition: true,
						masonry: {
							columnWidth: '.grid-sizer',
						},
					});
				}
			});

			$('.sendButton').attr('disabled',true);
			$('#pvm-input').keyup(function(){
				if($(this).val().length !=0){
					$('.sendButton').attr('disabled', false);
				} else {
					$('.sendButton').attr('disabled', true);        
				}
			})

			$filterLinks.click(function(){
				var $this = $(this);
				if ( $this.hasClass('selected') ) {
					return;
				}
				$filterLinks.filter('.selected').removeClass('selected');
				$this.addClass('selected');
				var selector = $this.data('option-value');
				$container.isotope({
					filter: selector,
				});
			});
		})
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js